import PdfComprovativoDesconto from "./PdfComprovativoDesconto";

function PdfComprovativoDescontoWrapper({
  showPreviousPage,
  comprovativoDescontoData,
}) {
  const showPreviousP = () => {
    showPreviousPage();
  };

  return (
    <div>
      <PdfComprovativoDesconto
        comprovativoDescontoData={comprovativoDescontoData}
        showPreviousPage={showPreviousP}
      />
    </div>
  );
}

export default PdfComprovativoDescontoWrapper;
